/*eslint-disable*/
import React, { useEffect, useState } from "react";
import "./styles.scss";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Checkbox, FormControlLabel } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import {
  GoogleMap,
  Marker,
  OverlayView,
  Polygon,
  useJsApiLoader,
} from "@react-google-maps/api";
import Moment from "moment";
import { connect } from "react-redux";
import { getVehicleByCode } from "../../../actions/rentals";
import { MAP_KEY } from "../../../configs/settings";
import { SECURINBOX } from "../../../constants/const";
import { useShowToast } from "../../../hooks";
import { strings } from "../../../I18n";
import greenBike from "../../../images/bikes/greenBike.png";
import ConfirmationDialog from "../confirmationDialog";

function InputDialogWithMap(props) {
  const {
    visibility,
    hideDialog,
    title,
    positiveAction,
    negativeAction,
    stationsList = [],
    docksList = [],
    rentalData = {},
    disablePast,
    getVehicleByCode,
    rentalBike,
  } = props;

  const [selectedStation, setStation] = useState("");
  const [selectedDock, setDock] = useState("");
  const [amount, setAmount] = useState((rentalData?.finalAmount || 0) / 100);
  const [endDate, setEndDate] = useState(rentalData?.endTime || "");
  const [isDockDisabled, disableDock] = useState(true);
  const [mapInstance, setMapInstance] = useState(null);
  const [autoFilledStation, setAutoFilledStation] = useState(false);
  const [autoFilledDock, setAutoFilledDock] = useState(false);
  const [isSecurinbox, setIsSecurinbox] = useState(false);
  const [mapZoom, setMapZoom] = useState(16);
  const [hasInitializedMap, setHasInitializedMap] = useState(false);
  const [mapCenter, setMapCenter] = useState(null);
  const [overrideAmount, setOverrideAmount] = useState(false);

  const showToast = useShowToast();

  const mapContainerStyle = {
    height: "50vh",
    width: "100%",
  };

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: MAP_KEY,
  });

  const onMapLoaded = (lMap) => {
    setMapInstance(lMap);
    const zoomListener = lMap.addListener("zoom_changed", () => {
      const zoom = lMap.getZoom();
      setMapZoom(zoom);
    });
    lMap._zoomListener = zoomListener;
  };

  useEffect(() => {
    if (rentalData) {
      setAmount(rentalData?.finalAmount / 100);
      setEndDate(rentalData?.endTime);

      if (rentalData?.endStationCode) {
        setStation(rentalData.endStationCode);
        setAutoFilledStation(true);
      }

      if (rentalData?.endDockCode) {
        setDock(rentalData.endDockCode);
        setAutoFilledDock(true);
      }

      if (rentalData?.vehicleCode) {
        getVehicleByCode(rentalData.vehicleCode);
      }
    }
  }, [rentalData]);

  useEffect(() => {
    if (rentalBike?.lock?.brand === SECURINBOX) {
      setIsSecurinbox(true);
    } else {
      setIsSecurinbox(false);
    }

    if (!rentalData?.endStationCode) {
      if (rentalBike?.station?.code) {
        setStation(rentalBike.station.code);
        setAutoFilledStation(true);
      } else if (
        rentalData?.latitude &&
        rentalData?.longitude &&
        stationsList?.length > 0
      ) {
        const bikeLocation = {
          lat: rentalData.latitude,
          lng: rentalData.longitude,
        };
        let closestStation = null;
        let minDistance = Infinity;

        stationsList.forEach((station) => {
          if (station?.latitude && station?.longitude) {
            const distance = Math.sqrt(
              (station.latitude - bikeLocation.lat) ** 2 +
                (station.longitude - bikeLocation.lng) ** 2
            );
            if (distance < minDistance) {
              minDistance = distance;
              closestStation = station;
            }
          }
        });

        if (closestStation) {
          setStation(closestStation.code);
          setAutoFilledStation(true);
        }
      }
    }
  }, [
    rentalBike,
    rentalData?.endStationCode,
    rentalData?.latitude,
    rentalData?.longitude,
    stationsList,
  ]);

  useEffect(() => {
    if (rentalData?.latitude && rentalData?.longitude && !mapCenter) {
      setMapCenter({ lat: rentalData.latitude, lng: rentalData.longitude });
    }
  }, [rentalData, mapCenter]);

  useEffect(() => {
    if (
      mapInstance &&
      rentalData?.latitude &&
      rentalData?.longitude &&
      !hasInitializedMap
    ) {
      const bikePosition = {
        lat: rentalData.latitude,
        lng: rentalData.longitude,
      };
      mapInstance.panTo(bikePosition);
      mapInstance.setZoom(16);
      setMapZoom(16);
      setHasInitializedMap(true);
    }
  }, [mapInstance, rentalData, hasInitializedMap]);

  useEffect(() => {
    if (
      !(
        (
          stationsList?.find((station) => station.code === selectedStation) ||
          {}
        )?.type === "CHARGE"
      )
    ) {
      disableDock(true);
    } else {
      disableDock(false);
      if (!autoFilledDock) {
        setDock("");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStation]);

  const dropContent = (item, type) => {
    if (type === "station") {
      return (
        <MenuItem key={item.code} value={item.code}>
          {item.name}
        </MenuItem>
      );
    } else if (type === "dock") {
      return (
        <MenuItem key={item.code} value={item.code}>
          {item.code}
        </MenuItem>
      );
    }
  };

  const endRent = () => {
    const data = {};
    if (selectedStation) {
      data.endStationCode = selectedStation;
    }
    if (selectedDock) {
      data.endDockCode = selectedDock;
    }
    if (endDate) {
      data.endTime = endDate;
    }

    if (overrideAmount) {
      if (amount !== "" && amount !== null && amount !== undefined) {
        data.finalAmount = amount * 100;
      }
      data.shouldAdjustAmount = false;
    } else {
      data.shouldAdjustAmount = true;
    }

    positiveAction(rentalData.id, data);
  };

  const remapDataToPath = (ldata) => {
    return ldata?.map((lGeometry, index) => {
      return {
        lat: parseFloat(lGeometry[0]),
        lng: parseFloat(lGeometry[1]),
      };
    });
  };

  const options = {
    clickable: true,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1,
    fillColor: "rgba(68,255,44,0.25)",
    strokeColor: "rgb(47,146,28)",
    strokeWeight: 2,
    cursor: "pointer",
  };

  const center = mapCenter || {
    lat: rentalData?.latitude || 0,
    lng: rentalData?.longitude || 0,
  };

  const divStyle = {
    background: "white",
    border: "1px solid #ccc",
    padding: 10,
  };

  return (
    <ConfirmationDialog
      visibility={visibility}
      hideDialog={hideDialog}
      title={title}
      positiveAction={endRent}
      negativeAction={negativeAction}
      selectedStation={selectedStation}
      disableAgree={
        selectedStation === "" ||
        (overrideAmount && (amount < 0 || amount === ""))
      }
      content={
        <DialogContent>
          {loadError ? (
            <div>
              <h1>{strings("descriptions.mpNotLoaded")}</h1>
            </div>
          ) : !isLoaded ? (
            <div>
              <h1>{strings("descriptions.loading")}</h1>
            </div>
          ) : (
            <GoogleMap
              id="marker-example"
              mapContainerStyle={mapContainerStyle}
              zoom={16}
              center={center}
              options={{
                gestureHandling: "greedy",
                zoomControl: true,
                disableDefaultUI: false,
                scrollwheel: true,
              }}
              onLoad={onMapLoaded}
              onUnmount={(map) => {
                if (map._zoomListener) {
                  window.google.maps.event.removeListener(map._zoomListener);
                }
                setMapInstance(null);
              }}
            >
              {props.mapData?.stations?.map((station, index) => {
                if (station?.latitude && station?.longitude) {
                  const isChargeStation = station?.type === "CHARGE";
                  const showLabel = mapZoom >= 16;

                  return (
                    <OverlayView
                      key={station?.code}
                      position={{
                        lat: station.latitude,
                        lng: station.longitude,
                      }}
                      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                    >
                      <div
                        onClick={(e) => {
                          e.stopPropagation();

                          const currentZoom = mapInstance
                            ? mapInstance.getZoom()
                            : 16;

                          if (currentZoom < 16 && mapInstance) {
                            mapInstance.setZoom(16);
                            setTimeout(() => {
                              mapInstance.panTo({
                                lat: station.latitude,
                                lng: station.longitude,
                              });
                            }, 50);
                          }

                          setStation(station.code);
                          setAutoFilledStation(false);
                        }}
                        style={{
                          position: "absolute",
                          transform: "translate(-50%, -50%)",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          pointerEvents: "auto",
                        }}
                      >
                        {showLabel && (
                          <div
                            style={{
                              background: isChargeStation
                                ? "#1976D2"
                                : "#388E3C",
                              color: "white",
                              padding: "6px 10px",
                              borderRadius: "6px",
                              fontSize: "13px",
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                              boxShadow: "0 3px 6px rgba(0,0,0,0.5)",
                              border: "3px solid white",
                              marginBottom: "4px",
                              textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
                            }}
                          >
                            {station?.name}
                          </div>
                        )}
                        <div
                          style={{
                            width: showLabel ? "16px" : "12px",
                            height: showLabel ? "16px" : "12px",
                            borderRadius: "50%",
                            background: isChargeStation ? "#1976D2" : "#388E3C",
                            border: showLabel
                              ? "3px solid white"
                              : "2px solid white",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.4)",
                          }}
                        />
                      </div>
                    </OverlayView>
                  );
                }
              })}

              <OverlayView
                position={{
                  lat: rentalData?.latitude || 0,
                  lng: rentalData?.longitude || 0,
                }}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
              >
                <div
                  style={{
                    position: "absolute",
                    transform: "translate(-50%, -50%)",
                    zIndex: 10000,
                    pointerEvents: "none",
                  }}
                >
                  <img
                    src={greenBike}
                    alt="bike"
                    style={{
                      width: "30px",
                      height: "30px",
                    }}
                  />
                </div>
              </OverlayView>
            </GoogleMap>
          )}
          <TextField
            value={selectedStation}
            onChange={({ target }) => {
              setStation(target.value);
              setAutoFilledStation(false);
            }}
            label={strings("descriptions.endStation")}
            select={true}
            fullWidth={true}
            margin="dense"
            required={true}
            helperText={
              autoFilledStation && rentalData?.endStationName
                ? `✓ ${strings("descriptions.autoDetectedStation", { stationName: rentalData.endStationName })}`
                : strings("descriptions.youMustSelectStation")
            }
            error={selectedStation === "" ? true : false}
            InputProps={
              autoFilledStation && selectedStation
                ? {
                    startAdornment: (
                      <InputAdornment position="start">
                        <Tooltip
                          title={strings(
                            "descriptions.autoDetectedFromVehicleState"
                          )}
                        >
                          <CheckCircleIcon fontSize="small" color="success" />
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }
                : undefined
            }
            sx={
              autoFilledStation && selectedStation
                ? {
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#e8f5e9",
                    },
                  }
                : undefined
            }
          >
            <MenuItem value={""}>
              <em>None</em>
            </MenuItem>
            {stationsList?.map((item) => dropContent(item, "station"))}
          </TextField>
          {!isDockDisabled && !isSecurinbox ? (
            <TextField
              value={selectedDock}
              onChange={({ target }) => {
                setDock(target.value);
                setAutoFilledDock(false);
              }}
              label={strings("descriptions.endDock")}
              select={true}
              fullWidth={true}
              margin="dense"
              helperText={
                autoFilledDock && selectedDock
                  ? `✓ ${strings("descriptions.autoDetectedDock", { dockCode: selectedDock })}`
                  : rentalData?.isDocked === false
                    ? strings("descriptions.vehicleNotDocked")
                    : null
              }
              InputProps={
                autoFilledDock && selectedDock
                  ? {
                      startAdornment: (
                        <InputAdornment position="start">
                          <Tooltip
                            title={strings(
                              "descriptions.autoDetectedFromVehicleState"
                            )}
                          >
                            <CheckCircleIcon fontSize="small" color="success" />
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }
                  : undefined
              }
              sx={
                autoFilledDock && selectedDock
                  ? {
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#e8f5e9",
                      },
                    }
                  : undefined
              }
            >
              <MenuItem value={""}>
                <em>None</em>
              </MenuItem>
              {docksList?.map((item) => dropContent(item, "dock"))}
            </TextField>
          ) : null}
          <DateTimePicker
            disablePast={disablePast}
            margin="dense"
            fullWidth={true}
            variant="inline"
            ampm={false}
            format={"DD-MM-YYYY HH:mm"}
            label={strings("descriptions.endTime")}
            value={endDate ? Moment(endDate + "Z") : null}
            onChange={(value) =>
              setEndDate(Moment(value).utc().format("YYYY-MM-DDTHH:mm:ss"))
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={overrideAmount}
                onChange={(e) => setOverrideAmount(e.target.checked)}
              />
            }
            label={strings("descriptions.overrideActualTripAmount")}
          />
          {overrideAmount && (
            <TextField
              onChange={({ target }) => setAmount(target.value)}
              value={amount}
              autoFocus={true}
              margin="dense"
              label={strings("placeholders.finalAmount")}
              type="number"
              fullWidth={true}
              inputProps={{
                min: 0,
                step: 0.01,
              }}
              helperText={strings("descriptions.finalAmountHelper")}
            />
          )}
        </DialogContent>
      }
    />
  );
}

const mapStateToProps = ({
  stations: { mapData },
  rentals: { rentalBike },
}) => ({
  mapData,
  rentalBike,
});

const mapDispatchToProps = {
  getVehicleByCode,
};

export default connect(mapStateToProps, mapDispatchToProps)(InputDialogWithMap);
